import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { authMe, isAdminRole } from "@/lib/api";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAuthenticated(false);
      navigate('/login');
      return;
    }

    // Try to get user from localStorage first for instant render
    const cachedUser = localStorage.getItem('user');
    if (cachedUser) {
      try {
        setUser(JSON.parse(cachedUser));
        setIsAuthenticated(true);
      } catch { /* cached user parse failed, will verify with backend */ }
    }

    // Verify token with backend
    const checkAuth = async () => {
      try {
        const response = await authMe();
        if (response.data) {
          setUser(response.data);
          setIsAuthenticated(true);
          localStorage.setItem('user', JSON.stringify(response.data));
        } else {
          setIsAuthenticated(false);
          navigate('/login');
        }
      } catch {
        // Auth verification failed - session expired or invalid
        setIsAuthenticated(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
      }
    };
    checkAuth();
  }, [navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-3 border-red-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500 font-medium">Yukleniyor...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  if (adminOnly && user && !isAdminRole(user)) return <Navigate to="/m" replace />;

  return children;
}
